import * as d3 from "d3";
import {axisTextDim1, colonAnnotation, inrFormatter, make_y_gridlines, responsivefy, XaxisAttribute} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, gridflag) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)
    // load the data
    // axios.post(url, filterParam).then(res => {
        let data = resData

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
        });

        var width2 = data.length * chart.vizSpecific2 > chart.width ? chart.width : data.length * chart.vizSpecific2
        // set the ranges
        var x1Scale = d3.scaleBand().rangeRound([0, width2]).padding(0.1);
        var y2Scale = Math.max(Math.abs(d3.min(data, (d) => {
            d.metric1
        })), Math.abs(d3.max(data, (d) => {
            d.metric1
        })));
        var y1Scale = d3.scaleLinear().domain([-y2Scale, y2Scale]).rangeRound([chart.height, 0]).nice();
        //var centerScale = d3.scaleLinear().range([0, width2]);
        // define the axis
        var x1AxisLabel = d3.axisBottom().scale(x1Scale);
        var y1AxisLabel = d3.axisLeft().scale(y1Scale).tickFormat(inrFormatter);
        //var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

        /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
            .html((d) =>{ return d.dim1_name+ colonAnnotation+ inrFormatter(d.metric1) })*/

        d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
        var div = d3.select(divId)
            .append('div')
            .attr('class', 'tooltip')
            .attr('style', 'position: absolute; opacity: 0;');

        // add the SVG element
        var svg = d3.select(divId).select("svg").remove();
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chart.width + chart.margin.left + chart.margin.right)
            .attr("height", chart.height + 5 * chart.margin.top + chart.margin.bottom)
            .call(responsivefy)
            .append("g")
            .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

        //Calling tooltip
        //svg.call(y1tip);

        // scale range of the data
        x1Scale.domain(data.map((d) => {
            return d.dim1_name
        }));
        y1Scale.domain([Math.min(0, d3.min(data, d => d.metric1)), Math.max(1, d3.max(data, d => d.metric1))]);

        // add axis
        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0," + chart.height + ")")
            .call(x1AxisLabel)
            .selectAll("text")
            //.attr("class","axisL20")
            .style('font-size', axisLabelFontSize)
            .style("text-anchor", "start")
            .attr("dx", XaxisAttribute)
            .attr("dy", "-.55em")
            .attr("transform", "translate(" + function (d, i) {
                return i * 45
            } + ", 0)")
            .attr("transform", "rotate(-50)")
            .text(axisTextDim1);

        svg.append('text')
            .attr('x', (chart.width / 3))
            .attr('y', chart.height + chart.margin.bottom + 2 * chart.vizSpecific1)
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.x1AxisDisplayName)

        svg.append("g")
            .attr("class", "y axis")
            .call(y1AxisLabel)
            .style("font-size", axisLabelFontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left + 2)
            .attr('x', 0 - (chart.height / 2) + 120)
            .attr("dy", ".71em")
            .style("text-anchor", "end")
            .style('fill', fontColor)
            .style('font-size', fontSize)
            .text(chart.y1AxisDisplayName)

        if (gridflag == true) {
            // add the X gridlines
            /* svg.append("g")
                .attr("class", "grid")
                .attr("transform", "translate(0," + chart.height + ")")
                .call(make_x_gridlines(x1Scale)
                    .tickSizeInner(-chart.height)
                    .tickFormat(""))*/

            // add the Y gridlines
            svg.append("g")
                .attr("class", "grid")
                .call(make_y_gridlines(y1Scale)
                    .tickSize(-chart.width)
                    .tickFormat(""))
        }

        //Add value top of the bar
        svg.selectAll('text.bar')
            .data(data)
            .enter()
            .append('text')
            .attr('class', 'bar')
            .attr('text-anchor', 'middle')
            .attr('x', (d) => {
                return x1Scale(d.dim1_name) + x1Scale.bandwidth() / 2
            })
            .attr('y', (d) => {
                return d.metric1 < 0 ? (y1Scale(d.metric1) + 25) : (y1Scale(d.metric1) - 5)
            })
            .text((d) => {
                return inrFormatter(d.metric1)
            })
            .attr('fill', 'black')
            .style('font-size', '30px')

        // Add bar chart
        svg.selectAll("bar")
            .data(data)
            .enter()
            .append("rect")
            .attr("class", function (d) {
                return "bar bar--" + (d.metric1 < 0 ? "bar" : "-bar");
            })
            .attr("x", (d) => {
                return x1Scale(d.dim1_name)
            })//Bar width of 20 plus 5 for padding
            .attr("width", x1Scale.bandwidth)
            .attr("y", function (d) {
                return y1Scale(Math.max(0, d.metric1))
            })
            .style("fill", (d) => {
                return d.dim3_name
            })
            .attr("height", (d) => {
                return Math.abs(y1Scale(d.metric1) - y1Scale(0))
            })
            .on("mousemove", function (d) {
                console.log(d3.event, d)
                div.transition()
                    .duration(200)
                    .style("opacity", .9);
                div.html(d.dim1_name + colonAnnotation + inrFormatter(d.metric1))
                    .style("left", (d3.event.layerX) + "px")
                    .style("top", (d3.event.layerY) + "px");
            })
            .on("mouseout", function () {
                div.transition().style("opacity", 0)
            });
        //.on('mouseover', y1tip.show)
        //.on('mouseout', y1tip.hide)
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
    // });
}
